import React from 'react';
import {_t} from "../../../js/app/common/utils/locale";

export default class FormErrors extends React.Component {

    render() {
        if (this.props.errors) {
            return (
                <div className="invalid-feedback">
                    {this.props.errors.map((error, key) =>
                        <div key={key}>{_t(error)}</div>
                    )}
                </div>
            );
        }
        return null;
    }

}